/* unplugin-vue-components disabled */import script from "./setup.vue?vue&type=script&setup=true&lang=js"
export * from "./setup.vue?vue&type=script&setup=true&lang=js"

import "./setup.vue?vue&type=style&index=0&id=2386c475&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2386c475"]])

export default __exports__